/**
 * Route for `nl-query-report-interface-ai-native`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { NlQueryReportInterfaceAiNativePage } from "../features/nl-query-report-interface-ai-native/NlQueryReportInterfaceAiNativePage";

export const nlQueryReportInterfaceAiNativeRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/nl-query-report-interface-ai-native",
	component: NlQueryReportInterfaceAiNativePage,
});

export default nlQueryReportInterfaceAiNativeRoute;
